import strings from '../../Localization/Localization';

let uuid = {
  fieldKey: "uuid",
  type: "text",
  label: strings.form.phoneSystemReportingConfiguration.uuid.label,
  validators: []
}

let fqdn = {
  fieldKey: "fqdn",
  type: "text",
  label: strings.form.phoneSystemReportingConfiguration.fqdn.label,
  validators: []
}

let server = {
  fieldKey: "server",
  type: "text",
  label: strings.form.phoneSystemReportingConfiguration.server.label,
  validators: []
}

let port = {
  fieldKey: "port",
  type: "text",
  label: strings.form.phoneSystemReportingConfiguration.port.label,
  validators: []
}

let user = {
  fieldKey: "user",
  type: "text",
  label: strings.form.phoneSystemReportingConfiguration.user.label,
  validators: []
}

let password = {
  fieldKey: "password",
  type: "text",
  label: strings.form.phoneSystemReportingConfiguration.password.label,
  validators: []
}

let active = {
  fieldKey: "active",
  type: "switch",
  label: strings.form.phoneSystemReportingConfiguration.active.label,
  validators: []
}

export const form = {
  formKey: "phoneSystemReportingConfiguration",
  fields: [
    uuid,
    fqdn,
    server,
    port,
    user,
    password,
    active
  ]
}
